const filterAnnualEarnings = data => {
  // Agrupar os dados por mês, apenas onde phase é "GANHOS"
  const monthCounts = {}

  data.forEach(item => {
    if (item.date && item.phase === 'GANHOS') {
      const date = new Date(item.date)
      const month = date.getMonth() // 0 = Janeiro, 11 = Dezembro

      if (monthCounts[month]) {
        monthCounts[month] += 1
      } else {
        monthCounts[month] = 1
      }
    }
  })

  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
  ]

  const labels = months
  const values = months.map((_, index) => monthCounts[index] || 0)

  return {
    labels,
    datasets: [
      {
        label: 'Ganhos anual',
        data: values,
        backgroundColor: Array(values.length).fill('#005C96'),
      },
    ],
  }
}

export default filterAnnualEarnings
